import { useEffect, useRef, useState } from "react";
import styled from "styled-components";

const RevealWrapper = styled.div`
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transform: ${({ $visible, $direction }) => {
    if ($visible) return "translateY(0) scale(1)";
    return $direction === "down"
      ? "translateY(-40px) scale(0.98)"
      : "translateY(40px) scale(0.98)";
  }};
  transition:
    opacity 0.65s cubic-bezier(0.22, 1, 0.36, 1),
    transform 0.65s cubic-bezier(0.22, 1, 0.36, 1);
  transition-delay: ${({ $delay }) => $delay}ms;
  will-change: opacity, transform;

  @media (prefers-reduced-motion: reduce) {
    opacity: 1;
    transform: none;
    transition: none;
  }
`;

/**
 * direction="up"    → montée (bas → haut), un par un
 * direction="down"  → descente (haut → bas), un par un
 * index             → décalage pour effet séquentiel
 */
const ScrollReveal = ({
  children,
  direction = "up",
  index = 0,
  stagger = 120,
  threshold = 0.15,
  className,
  style,
  as: Component = "div",
}) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.unobserve(node);
        }
      },
      { threshold, rootMargin: "0px 0px -8% 0px" }
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [threshold]);

  const delay = index * stagger;

  return (
    <RevealWrapper
      ref={ref}
      as={Component}
      $visible={visible}
      $direction={direction}
      $delay={delay}
      className={className}
      style={style}
    >
      {children}
    </RevealWrapper>
  );
};

export default ScrollReveal;
